import { createRoutine } from "redux-saga-routines";
import ActionTypes from "./constants";

export const track = createRoutine(ActionTypes.TRACK);

export const identify = createRoutine(ActionTypes.IDENTIFY);

export default {};
